import { withNamespaces } from 'react-i18next';
import { useHistory, useParams } from 'react-router-dom';
import {
    Col,
    Container,
    Row,
    Spinner,
} from 'reactstrap';

import Navigator from 'src/components/Navigator';
import {
    ROUTE_PATH_ADMIN_GUARD_BID_SUMMARY,
    ROUTE_PATH_ADMIN_GUARD_FREIGHT_DETAILS,
    ROUTE_PATH_ADMIN_GUARD_FREIGHTS_LIST,
} from 'src/modules/3rd-party-management/constants';
import useCarrierGuardBidDetails from '../hooks/useCarrierGuardBidDetails';
import BidVerificationFlow from './components/BidVerificationFlow';
import useBidVerificationFlow from './hooks/useBidVerificationFlow';

const VerificationFlowContent = ({
    bid,
}) => {
    const {
        getActiveSignals,
        getEdgeTrails,
        liveBranchId,
        nodes,
        pause,
        relationships,
        reset,
        start,
        status,
    } = useBidVerificationFlow(bid);

    return (
        <BidVerificationFlow
            bid={bid}
            getActiveSignals={getActiveSignals}
            getEdgeTrails={getEdgeTrails}
            liveBranchId={liveBranchId}
            nodes={nodes}
            onPause={pause}
            onReset={reset}
            onStart={start}
            relationships={relationships}
            status={status}
        />
    );
};

const GuardBidVerificationFlow = ({
    t,
}) => {
    const { freightId, bidId } = useParams();
    const history = useHistory();
    const {
        data: bid,
        isError,
        isFetching,
    } = useCarrierGuardBidDetails({
        freightId,
        bidId,
        t,
    });

    if (isFetching) {
        return (
            <div className="page-content">
                <Container className="py-5 text-center" fluid>
                    <Spinner color="primary" />
                    <p className="mt-2">{t('Loading')}...</p>
                </Container>
            </div>
        );
    }

    if (isError || !bid) {
        return (
            <div className="page-content">
                <Container fluid>
                    <div className="alert alert-danger" role="alert">
                        {t(isError ? 'Unable to load bid details. Please try again.' : 'Bid not found.')}
                    </div>
                </Container>
            </div>
        );
    }

    const freightDetailsPath = ROUTE_PATH_ADMIN_GUARD_FREIGHT_DETAILS
        .replace(':freightId', bid.freightId);
    const bidSummaryPath = ROUTE_PATH_ADMIN_GUARD_BID_SUMMARY
        .replace(':freightId', bid.freightId)
        .replace(':bidId', bid.id);

    return (
        <div className="page-content carrier-guard-page carrier-guard-bid-flow-page">
            <Container fluid>
                <Row>
                    <Col className="mb-4" lg="12">
                        <Navigator
                            backButtonOptions={(defaults) => ({
                                ...defaults,
                                enable: true,
                                title: 'Back to bids',
                                onClick: () => history.push(`${freightDetailsPath}?tab=bids`),
                            })}
                            breadCrumbs={[
                                {
                                    title: 'Freights',
                                    link: ROUTE_PATH_ADMIN_GUARD_FREIGHTS_LIST,
                                },
                                {
                                    title: bid.freightReference,
                                    link: `${freightDetailsPath}?tab=bids`,
                                },
                                {
                                    title: bid.carrier,
                                    link: bidSummaryPath,
                                },
                                {
                                    title: 'Live Verification Flow',
                                    link: '#',
                                },
                            ]}
                        />
                    </Col>
                </Row>

                <VerificationFlowContent bid={bid} />
            </Container>
        </div>
    );
};

export default withNamespaces()(GuardBidVerificationFlow);
